import KeycloakLoginContainer from './KeycloackLoginContainer';

export {
  KeycloakLoginContainer
};

export default KeycloakLoginContainer;
